import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";

import {HttpCommonService} from "../services/http-common.service";
import {NzMessageService, NzModalService} from "ng-zorro-antd";
import {Injectable} from "@angular/core";
import {GlobalService} from "../services/global.service";
import {PaymentService} from "../services/payment.service";

@Injectable()
export class PayGuard implements CanActivate{

  constructor(private msg: NzMessageService,
              public http: HttpCommonService,
              private globalService: GlobalService,
              private paySev: PaymentService,private showNzModal: NzModalService,
              private router: Router){}

  canActivate(routerInfo: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    console.log('pay guard...');
    let orderNo  = routerInfo.queryParams["orderNo"];
    //先判断登录状态，如果未登录获取游客token
    this.getUserLoginStatus();
    return this.paySev.getOrderByNo(orderNo).map((result)=>{
      let order = result.data;
      if (result.stateCode == '30301') {
        if (!order) {
          // this.msg.error("该订单不存在");
          this.showNzModal.error({
            content: '该订单不存在',
            okText: '确定',
            onOk: () => { this.router.navigateByUrl("/"); },
            onCancel: () => { this.router.navigateByUrl("/"); }
          });
          return false;
        } else if (order.payStatus == '1') {
          // this.msg.error("该订单已经付款，请勿重复支付");
          this.showNzModal.error({
            content: '该订单已经付款，请勿重复支付',
            okText: '确定',
            onOk: () => { this.router.navigateByUrl("/"); },
            onCancel: () => { this.router.navigateByUrl("/"); }
          });
          return false;
        }else if(order.orderStatus == "2"){
          this.showNzModal.warning({
            content: '您的订单超过48小时未支付，已经关闭。<br/>请重新提交入驻订单。',
            okText: '确定',
            onOk: () => { this.router.navigateByUrl("/"); },
            onCancel: () => { this.router.navigateByUrl("/"); }
          });
          return false;
        } else {
          return true;
        }
      } else if (result.stateCode == '30305') { // 订单编号为空
        // this.msg.error("订单编号不能为空");
        this.showNzModal.error({
          content: '订单编号不能为空',
          okText: '确定',
          onOk: () => { this.router.navigateByUrl("/"); },
          onCancel: () => { this.router.navigateByUrl("/"); }
        });
        return false;
      } else {
        return true;
      }
    }).first();
  }

  getUserLoginStatus() {
    this.http.get("/auth/jwt/isLogin").subscribe(result => {
      // 已登录
      if (result.stateCode == '20111') {
        this.globalService.setLoginState(true);
        if (result.data.userType !== 'enterprise' && result.data.userType !== 'person') {
          if (this.globalService.isFirstAccess == '0') {
            this.getTouristToken();
          }
        }
      } else {
        this.globalService.deleteLocalStorage();
        if (this.globalService.isFirstAccess == '0') {
          this.getTouristToken();
        }
      }
      this.globalService.isFirstAccess = '1';
      this.globalService.checkLoginState();
    });
    if (this.globalService.isFirstAccess == '0') {
      this.getTouristToken();
    }
    this.globalService.isFirstAccess = '1';
  }

  getTouristToken() {
    this.http.get("/auth/jwt/generateTouristToken").subscribe(result => { });
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/guard/PayGuard.ts